import React, { Component } from "react";
import "../assets/scss/carousel.scss";


import alternate from "../assets/img/altnerete-ekip-uptade.webp"

class Slider extends Component {
    constructor(props) {
    super(props);

    this.state = {
      display: false,
      value: ''
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    e.preventDefault();

    this.setState({ value: e.target.value });
  }
  showModal(e) {

    this.setState({ display: !this.state.display });
    document.querySelector('.check-modal').classList.add('active-modal');

    document.querySelector('#site').innerHTML = this.state.value;
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector('.check-modal').classList.remove('active-modal');
  }


 

  render() {
    const { currentIndex } = this.state;

    return (
      <div className="container sliderup">
            <div className="col-md-6">
      <div style={{
        display: "inline-flex",
        alignItems: "center",
        background: "rgba(254, 152, 0, 0.07)",
        color: "#B89C5A",
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "16px",
        padding: "4px 16px",
        
      }}>
        <span  className="slider-span">
          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99983 16.8333C4.39745 16.8333 0.666504 13.1023 0.666504 8.49999C0.666504 3.89762 4.39745 0.166656 8.99983 0.166656C13.6021 0.166656 17.3331 3.89762 17.3331 8.49999C17.3331 13.1023 13.6021 16.8333 8.99983 16.8333ZM8.16866 11.8333L14.0612 5.94077L12.8827 4.76226L8.16866 9.47629L5.81167 7.11924L4.63315 8.29779L8.16866 11.8333Z" fill="#FF9900"/>
          </svg>
        </span>
        We Believe in the Power of Data!
      </div>
      <div className="slider-h1">
      End-to-End Digital<br />
  Solutions that<br />
  Prioritize Performance
      </div>
      <p className="slider-p">
     With a team of over 25 experts, we have been supporting the digital growth journeys of national and international brands for years. <br />
  To date, we’ve designed data-driven and performance-focused strategies for hundreds of projects.
      </p>
      <img className="slider-imgs" src={alternate} />
       <div className="slider-buttons">
              <a className="slider-red" href="/proje-baslat/" target="_blank">
                <button className="red-button uptade ss"> &nbsp; Start Project &nbsp; </button>
              </a>
              <button onClick={(e) => this.showModal()} className="red-button uptade ss">Free Report</button>
        </div>
    </div>
    
            <div className="col-md-6 tel">
              
              <video
              className={`slider-video desktop ${currentIndex === 0 ? "active" : ""} ss`}
  src="https://cdn.popupsmart.com/flatart/flatart-yeni-slider.mp4"
    autoPlay
    loop
    muted
    playsInline
    style={{ width: "100%", height: "auto", display: "block", borderRadius: "12px" }}
  />
            </div>
    
    
          </div>
    );
  }
}

export default Slider;
